<script>
  import Gt800px from "./components/Gt800px.svelte";
  import Gt600px from "./components/Gt600px.svelte";
  import Gt360px from "./components/Gt360px.svelte";
  let availableWidth = 0;
  // restart animations on a given dom element
  const restartAnimations = (element) => {
    for (const animation of document.getAnimations()) {
      if (element.contains(animation.effect.target)) {
        animation.cancel();
        animation.play();
      }
    }
  };

  $: {
    if (availableWidth > 0) {
      clearInterval(timer);
      timer = setInterval(() => {
        restartAnimations(document.querySelector(".bannerLg"));
      }, animationDuration);
    }
  }

  const animationDuration = 15000; //ms
  let timer = setInterval(() => {
    restartAnimations(document.querySelector(".bannerLg"));
  }, animationDuration);

  const currentUrl = document.referrer;

</script>

<div class="guide" bind:clientWidth={availableWidth}>&nbsp;</div>
{#if availableWidth >= 700}
  <Gt800px {currentUrl}/>
{:else if availableWidth >= 450}
  <Gt600px {currentUrl} />
{:else}
  <Gt360px {currentUrl}/>
{/if}

<style>
  .guide {
    width: 100%;
    height: 1px;
    opacity: 0;
  }
</style>
